/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectTaskCommand } from '../../models/create-project-task-command';
import { CreateProjectTaskCommandResult } from '../../models/create-project-task-command-result';

export interface ApiProjectTaskCreateProjectTaskPost$Params {
      body?: CreateProjectTaskCommand
}

export function apiProjectTaskCreateProjectTaskPost(http: HttpClient, rootUrl: string, params?: ApiProjectTaskCreateProjectTaskPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectTaskCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectTaskCreateProjectTaskPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectTaskCommandResult>;
    })
  );
}

apiProjectTaskCreateProjectTaskPost.PATH = '/api/ProjectTask/CreateProjectTask';
